import { View, Text } from 'react-native'
import { useNetworkStatus } from '../../hooks/useNetworkStatus'
import { OFFLINE_BANNER_COPY } from '../../constants/dataLoadError.constants'
import { offlineBannerStyles as styles } from './OfflineBanner.styles'

export function OfflineBanner() {
  const { isOffline } = useNetworkStatus()

  if (!isOffline) {
    return null
  }

  return (
    <View style={styles.container} testID="offline-banner">
      <Text style={styles.text}>{OFFLINE_BANNER_COPY.MESSAGE}</Text>
    </View>
  )
}
